import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const VARIANTS = {
  primary:
    "bg-primary text-white hover:bg-white hover:text-primary border border-primary cursor-pointer",
  secondary:
    "bg-transparent text-primary border border-primary hover:bg-primary hover:text-white cursor-pointer",
  ghost: "bg-transparent text-primary hover:bg-primary/10 cursor-pointer",
  danger:
    "bg-red-600 text-white hover:bg-white hover:text-red-600 border border-red-600 cursor-pointer",
  success:
    "bg-green-600 text-white hover:bg-white hover:text-green-600 border border-green-600 cursor-pointer",
  featured:
    "bg-white text-primary border border-primary hover:bg-gray-200 cursor-pointer",

  // Pricing cards
  pricingOutline:
    "bg-white text-[#162536] border border-[#162536] hover:bg-[#162536] hover:text-white cursor-pointer",
  pricingFeatured:
    "bg-white text-[#162536] border border-white hover:bg-gray-100 hover:text-[#162536] cursor-pointer",
};
const SIZES = {
  sm: "px-3 py-1 text-sm",
  md: "px-5 py-2 text-base",
  lg: "px-7 py-3 text-lg",
  xl: "px-9 py-4 text-xl",
};

const Button = ({
  children,
  text,
  url,
  blank = false,
  type = "button",
  loading = false,
  disabled = false,
  onClick,
  variant = "primary",
  size = "md",
  leftIcon,
  rightIcon,
  className = "",
}) => {
  const { i18n } = useTranslation();
  const isAR = i18n.resolvedLanguage?.startsWith("ar");

  const baseClasses = `
    inline-flex items-center justify-center gap-2
    rounded-lg font-medium
    transition-all duration-200
    disabled:opacity-60 disabled:cursor-not-allowed
    ${VARIANTS[variant] || VARIANTS.primary}
    ${SIZES[size] || SIZES.md}
    ${className}
  `;

  const content = (
    <>
      {leftIcon && (
        <span className={isAR ? "order-2" : "order-1"}>{leftIcon}</span>
      )}

      <span className={isAR ? "order-1" : "order-2"}>
        {loading ? "Loading..." : children || text}
      </span>

      {rightIcon && (
        <span className={isAR ? "order-0" : "order-3"}>{rightIcon}</span>
      )}
    </>
  );

  // LINK MODE
  if (url) {
    return (
      <Link
        to={url}
        target={blank ? "_blank" : "_self"}
        className={baseClasses}
      >
        {content}
      </Link>
    );
  }

  // BUTTON MODE
  return (
    <button
      type={type}
      onClick={onClick}
      className={baseClasses}
      disabled={disabled || loading}
    >
      {content}
    </button>
  );
};

export default Button;
